import { alertMessageAction } from "./types"

const initialState = {
    message: "",
    status: "",
    time: 2
}

export const alertMessageReducer = (state = initialState,{type, message, status, time}) => {
    console.log("Reducer received action:", type, { message, status, time }); // Debug log
    switch(type){
        case alertMessageAction.SET_MESSAGE:
            console.log("Setting success/error message in reducer:", { message, status, time }); // Debug log
            return {
                ...state, 
                message: message,
                status: status,
                time: time,
            }
        case alertMessageAction.REMOVE_MESSAGE:
            console.log("Removing message from reducer"); // Debug log
            return {
                ...state, 
                message: "",
                status: "",
                time: 2,
            }      
        default: return state;
    }
}

